import React from 'react';

function FilteredPlaceHolder() {
    return (
        <>
            <div className="headerSection">
                <div className="col-xs-12 col-md-9 padding-0">
                    <div className="skeleton__loading">
                        <div className="skeleton__headline skeleton__placeholder" />
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 padding-0">
                    <div className="display-flex gap-2">
                        <div className="skeleton__loading flex-1">
                            <div className="skeleton__headline skeleton__placeholder" />
                        </div>
                        <div className="skeleton__loading flex-1">
                            <div className="skeleton__headline skeleton__placeholder" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="resultCount margin-vertical-5">
                <div className="skeleton__loading">
                    <div className="skeleton__headline skeleton__placeholder" />
                </div>
            </div>
        </>
    );
}

export default FilteredPlaceHolder;
